import React from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { AddFreeListing as AddFreeListingContent } from "../../../../addFreeListing";
import { Modal } from "../../../../common/modal";
import { OverlayPreloader } from "../../../../common/preloader";
import styles from "./addFreeListing.module.css";

export const AddNewListing = ({ clearAllModals, closeModal, listingModalListingType }) => {
  const { preloaders } = useSelector(state => state.home);
  const location = useLocation();
  const isMyEventsPage = location.pathname.includes("/my-events") || listingModalListingType.includes("/my-events");
  const isMyJobsPage = location.pathname.includes("/my-jobs") || listingModalListingType.includes("/my-jobs");
  const isOrganizationsPage = location.pathname.includes("/my-organizations") || listingModalListingType.includes("/my-organizations");
  const isEventsJobsOrOrganizations = isMyEventsPage || isMyJobsPage || isOrganizationsPage;
  const modalClassname = isEventsJobsOrOrganizations ? styles.modalHide : "";
  const buttonClassname = isEventsJobsOrOrganizations ? styles.button : "";

  return (
    <>
      {isEventsJobsOrOrganizations && preloaders.listingAssistant ? <OverlayPreloader /> : null}
      <Modal
        closeModal={closeModal}
        clearAllModals={clearAllModals}
        classNameMain={cn(styles.modal, modalClassname)}
        classNameButton={buttonClassname}
      >
        {preloaders.listingAssistant && !isEventsJobsOrOrganizations && <OverlayPreloader />}
        <AddFreeListingContent handleClose={closeModal} isModal listingModalListingType={listingModalListingType} />
      </Modal>
    </>
  );
};
